import React from 'react';
import './Button.css';

const Button = ({ 
  children, 
  className = '', 
  onClick, 
  type = 'button', 
  variant = 'primary',
  size = 'medium',
  loading = false,
  disabled = false,
  ripple = false,
  ...props 
}) => {
  const getSizeClass = () => {
    switch (size) {
      case 'small': return 'small';
      case 'large': return 'large';
      default: return '';
    }
  };

  const buttonClasses = [
    'button',
    variant,
    getSizeClass(),
    loading ? 'loading' : '',
    ripple ? 'ripple' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || loading}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
